module.exports = __webpack_public_path__ + "assets/2da22ac0c94f220a61d244286583505d.json";